import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import { useMediaQuery } from "usehooks-ts";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  height: "fit-content",
  bgcolor: "rgba(47,26,111,0.91)",
  boxShadow: 24,
  p: 4,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  color: "#FFF",
  textAlign: "center",
  borderRadius: "12px",
};

const ModalWrapper = styled("div")``;

const ModalContainer = styled("div")`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70vw;
  max-width: 700px;
  height: fit-content;
  background: rgba(47, 26, 111, 0.91);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 11px 15px -7px,
    rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px;
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #fff;
  text-align: center;
  border-radius: 12px;
`;

export default function BasicModal({ open, handleClose, children }) {
  const isMobile = useMediaQuery("(max-width: 724px)");
  return (
    <ModalWrapper>
      <Modal
        open={open}
        onClose={handleClose}
        hideBackdrop={false}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalContainer className="modalStyle modalContainer">
          {children}
        </ModalContainer>
      </Modal>
    </ModalWrapper>
  );
}
